import { createReducer, on } from '@ngrx/store';
import { EventCategoriesActionTypes } from '../actions/event-categories.actions';
import { CategoriesWithAssignments } from '../../services/event-categories.service-data-service';

export const EVENT_CATEGORY_KEY = 'categoriesWithAssignments';

export interface EventCategoriesState {
    categoriesWithAssignments: CategoriesWithAssignments | null;
    fetched: boolean;
}

const initialState: EventCategoriesState = {
    categoriesWithAssignments: null,
    fetched: false
};

export const eventCategoriesReducer = createReducer(
    initialState,
    on(EventCategoriesActionTypes.Load, (state) => ({
        ...state,
        fetched: false
    })),
    on(EventCategoriesActionTypes.LoadSuccess, (state, { Payload }) => ({
        ...state,
        categoriesWithAssignments: Payload,
        fetched: true
    })),
    on(EventCategoriesActionTypes.CreateSuccess, (state, { Payload }) => ({
        ...state,
        categoriesWithAssignments: {
            ...state.categoriesWithAssignments,
            EventCategories: [...(state.categoriesWithAssignments?.EventCategories || []), Payload]
        }
    })),
    on(EventCategoriesActionTypes.CreateSuccessE2EC, (state, { Payload }) => ({
        ...state,
        categoriesWithAssignments: {
            ...state.categoriesWithAssignments,
            Event2EventCategories: [...(state.categoriesWithAssignments?.Event2EventCategories || []), Payload]
        }
    })),
    on(EventCategoriesActionTypes.UpdateSuccess, (state, { Payload }) => ({
        ...state,
        categoriesWithAssignments: {
            ...state.categoriesWithAssignments,
            EventCategories: state.categoriesWithAssignments?.EventCategories.map(cat =>
                cat.Id === Payload.Id ? Payload : cat
            ) || []
        }
    })),
    on(EventCategoriesActionTypes.DeleteSuccessE2EC, (state, { Payload }) => ({
        ...state,
        categoriesWithAssignments: {
            ...state.categoriesWithAssignments,
            Event2EventCategories: state.categoriesWithAssignments?.Event2EventCategories.filter(cat => cat.Id.toString() !== Payload) || []
        }
    })),
    on(EventCategoriesActionTypes.DeleteSuccess, (state, { Payload }) => ({
        ...state,
        categoriesWithAssignments: {
            ...state.categoriesWithAssignments,
            EventCategories: state.categoriesWithAssignments?.EventCategories.filter(cat => cat.Id.toString() !== Payload) || []
        }
    }))
);
